// extracted by mini-css-extract-plugin
module.exports = {"roleCard":"RoleCard_roleCard__1quFN","card":"RoleCard_card__1w0vI","roleInfo":"RoleCard_roleInfo__34HY8"};